import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getTransfers = async ({ currencyId, pageNumber = 1 }) => {
  if (!currencyId) return Promise.resolve([]); // Prevent API call if currencyId is undefined
  console.log('Fetching transfers for:', { currencyId, pageNumber });
  return axios.get(`/transaction/transfer/${currencyId}/${pageNumber}`);
};

export const useTransfers = ({ currencyId, pageNumber = 1, config }) => {
  return useQuery({
    ...config,
    queryKey: ['transfers', currencyId, pageNumber], // ✅ Query key now includes currencyId
    queryFn: () => getTransfers({ currencyId, pageNumber }),
    enabled: !!currencyId, // ✅ Prevents execution if currencyId is null/undefined
  });
};
